import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import PageHeader from "@/templates/modern/elements/PageHeader";

const elements = {
  PageHeader,
};

export function SharedElementsLoader(props: { children: ReactNode }) {
  StoreTemplate.load("modern", "shared", elements);
  return props.children;
}
